import { render, staticRenderFns } from "./NftHistoryList.vue?vue&type=template&id=74bff5a4&scoped=true&"
import script from "./NftHistoryList.vue?vue&type=script&lang=js&"
export * from "./NftHistoryList.vue?vue&type=script&lang=js&"
import style0 from "./NftHistoryList.vue?vue&type=style&index=0&id=74bff5a4&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "74bff5a4",
  null
  
)

export default component.exports